/*
<summary>
   This file defines axios interceptors have request handler and error handler.
</summary>
*/
import axios, { AxiosResponse } from 'axios';
import { clearLocalStorageFields } from '../../constants/constants';
import { errorMessage } from '../../constants/error-constants';
import config from '../../helpers/config-helper';
import { AuthStore } from '../stores/auth-store';
import RoutesConstants from '../../constants/routes.constant';

const appConfig = config();
export const baseURL = appConfig.REACT_APP_API_URL;
export const baseAPI = axios.create({ baseURL });
const requestHandler = (request: any) => {
  const token = new AuthStore().getToken;
  request.headers = request.headers || {};
  request.headers['authorization'] = 'Bearer ' + token;
  request.headers['Cache-Control'] = 'no-cache';
  request.headers['Pragma'] = 'no-cache';
  request.headers['Expires'] = '0';

  const method = (request.method || 'get').toLowerCase();
  if (method === 'get') {
    request.params = {
      ...(request.params || {}),
      ts: Date.now(),
    };
  }
  return request;
};
const errorHandler = async (error: any) => {
  let message: string = errorMessage.ErrorOccured;
  if (error.response) {
    if (
      error.response.status === 401 &&
      error.response.data.Message != errorMessage.InvalidUserIdOrPassword &&
      error.response.data.Message != errorMessage.YourAccountInactive &&
      error.response.data.Message != errorMessage.UserEmailNotFound
    ) {
      message = error.response.data.Message;
      clearLocalStorageFields();
      if (!message) {
        setTimeout(() => {
          window.location.href = RoutesConstants.Login;
        }, 2000);
      }
      // setTimeout(() => {
      //   window.location.href = RoutesConstants.Login;
      // }, 2000);
      return Promise.reject(message);
    } else if (error.response.status === 403) {
      message = errorMessage.UnauthorizedAccess;
    } else if (
      error.response.data &&
      error.response.data.Message &&
      error.response.data.Message !== null &&
      error.response.data.Message !== undefined
    ) {
      message = error.response.data.Message;
    }
  }
  return Promise.reject(message);
};

const successHandler = (response: AxiosResponse): AxiosResponse => {
  return response;
};

baseAPI.interceptors.request.use((request) => requestHandler(request));
baseAPI.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);
